<template>
  <v-card class="light-preview">
    <v-img
      :src="image"
      class="grey lighten-2"
      height="150px"
    >
      <v-container
        fill-height
        fluid
        pa-2
        class="bg-gradient"
      >
        <v-layout fill-height>
          <v-flex xs12 align-end flexbox>
            <h4 class="headline white--text">{{ name }}</h4>
          </v-flex>
        </v-layout>
      </v-container>
      <v-layout
        slot="placeholder"
        fill-height
        align-center
        justify-center
        ma-0
      >
        <v-progress-circular indeterminate color="secondary"></v-progress-circular>
      </v-layout>
    </v-img>
    <v-card-text>
      <slot></slot>
    </v-card-text>
    <div class="light-preview__add layout align-center justify-center">
      <v-avatar color="secondary" size="60" class="light-preview__add-icon">
        <v-icon dark>add_circle</v-icon>
      </v-avatar>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'LightPreview',
  props: {
    name: {
      required: true,
      type: String
    },
    image: {
      required: true,
      type: String
    }
  }
}
</script>

<style scoped lang="scss">
.light-preview {
  position: relative;
  overflow: hidden;
}

.light-preview__add {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: rgba(0,0,0,0.7);
  transition: opacity 0.3s ease;
  opacity: 0;
}

.light-preview__add-icon {
  transform: scale(0);
  transition: transform 0.3s ease;
  transition-delay: 0s;
}

.light-preview:hover {
  cursor: pointer;

  .light-preview__add {
    opacity: 1;
  }

  .light-preview__add-icon {
    transform: scale(1);
    transition-delay: 0.1s;
  }
}

.bg-gradient {
  background: linear-gradient(to bottom, #020e17 0%, rgba(15, 148, 246, 0.27) 60%);
}
</style>
